// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"38d4fe0e","977":"424de69d"}[chunkId] + ".chunk.js";
};